/**
 * Resize an image File into a square data URL suitable for storing in
 * UserProfile.avatar_url without needing object storage. Crops centre,
 * downscales to ``size`` × ``size``, JPEG-encodes at the given quality.
 *
 * Result is small enough (< 50 KB at 256 / 0.85) to fit in a TextField
 * without bloating the row, and can be rendered directly with <img src=...>.
 */
export const fileToSquareDataURL = (
  file,
  { size = 256, quality = 0.85, mimeType = "image/jpeg" } = {},
) =>
  new Promise((resolve, reject) => {
    if (!file) return reject(new Error("No file provided"));
    if (!file.type?.startsWith("image/")) {
      return reject(new Error("Selected file is not an image"));
    }
    const reader = new FileReader();
    reader.onerror = () => reject(reader.error || new Error("Could not read file"));
    reader.onload = () => {
      const img = new Image();
      img.onload = () => {
        const minSide = Math.min(img.width, img.height);
        const sx = (img.width - minSide) / 2;
        const sy = (img.height - minSide) / 2;

        const canvas = document.createElement("canvas");
        canvas.width = size;
        canvas.height = size;
        const ctx = canvas.getContext("2d");
        if (!ctx) return reject(new Error("Canvas not supported"));
        ctx.imageSmoothingEnabled = true;
        ctx.imageSmoothingQuality = "high";
        ctx.drawImage(img, sx, sy, minSide, minSide, 0, 0, size, size);
        resolve(canvas.toDataURL(mimeType, quality));
      };
      img.onerror = () => reject(new Error("Could not decode image"));
      img.src = reader.result;
    };
    reader.readAsDataURL(file);
  });
